var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dt-paging" }, [
    _c(
      "div",
      {
        staticClass: "item-per-page",
        class: _vm.pagingObj.itemsPerPage == "SHOW ALL" ? "show-all" : null
      },
      [
        _c("v-select", {
          staticClass: "select",
          attrs: { options: ["25", "50", "SHOW ALL"], searchable: false },
          model: {
            value: _vm.pagingObj.itemsPerPage,
            callback: function($$v) {
              _vm.$set(_vm.pagingObj, "itemsPerPage", $$v)
            },
            expression: "pagingObj.itemsPerPage"
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "text" }, [_vm._v(" events on pages.")])
      ],
      1
    ),
    _vm._v(" "),
    _vm.itemsPerPage / _vm.totalItems <= 1
      ? _c(
          "div",
          { staticClass: "select-page-number" },
          [
            _c("b-pagination", {
              attrs: {
                size: "md",
                "total-rows": _vm.totalItems,
                "per-page":
                  _vm.pagingObj.itemsPerPage == "SHOW ALL"
                    ? 10000
                    : parseInt(_vm.pagingObj.itemsPerPage)
              },
              model: {
                value: _vm.pagingObj.currentPage,
                callback: function($$v) {
                  _vm.$set(_vm.pagingObj, "currentPage", $$v)
                },
                expression: "pagingObj.currentPage"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-17e9ccf1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17e9ccf1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatable/DtPaging.vue
// module id = 1506
// module chunks = 1